import React from "react";

import { useIntl } from "react-intl";

import { LabeledSwitch } from "@app/component/input/LabeledSwitch";

interface Props {
  onChange?: (value: boolean) => void;
  value?: boolean;
}

const ExportUid: React.FC<Props> = ({ onChange, value }) => {
  const intl = useIntl();

  return (
    <LabeledSwitch
      checked={value}
      description={intl.formatMessage({
        id: "settings.organizationDetails.data.exports.switch.description",
        defaultMessage:
          "If your Unique IDs need to keep leading zeros, we recommend turning this on. When this is on, we turn the cell into a text field by adding an apostrophe prefix to Unique IDs. This prevents leading zeros from being removed.",
        description: "Settings organization details - Data - Exports - description",
      })}
      onChange={onChange}
      title={intl.formatMessage({
        id: "settings.organizationDetails.data.exports.switch.title",
        defaultMessage: "Add apostrophes to Unique ID in exports",
        description: "Exports settings switch title",
      })}
    />
  );
};

export default ExportUid;
